import {StyleSheet} from 'react-native';

import {indent} from '/constant/layout.constant';
import {denim, grayscale, grey80} from '/theme/color/on.color';
import {codGray} from '/theme/color/secondary.color';

export const styles = StyleSheet.create({
  base: {},
  closeIcon: {
    fontSize: 20,
    color: grayscale,
    marginRight: indent * 0.5,
  },
  headerText: {
    fontSize: 16,
    color: codGray,
    marginLeft: 10,
  },
  modalHeader: {
    flexDirection: 'row',
    paddingHorizontal: 5,
  },
  saveText: {
    fontSize: 16,
    position: 'absolute',
    paddingTop: 0,
    right: 20,
    color: denim,
  },
  saveTextDisable: {
    fontSize: 16,
    position: 'absolute',
    paddingTop: 0,
    right: 20,
    color: grey80,
  },
  marginTop: {
    marginTop: 2,
  },
  radioButtonsContainer: {
    flexDirection: 'column',
    marginHorizontal: 10,
    marginVertical: 20,
  },
});
